import { GetterTree } from "vuex";
import { AppState } from "./app.module";
import { RootState } from "..";
import { ToastModel } from "@/interfaces/app/toast-model";

export const APP_GETTERS: GetterTree<AppState, RootState> = {
  getToastModal(state): ToastModel {
    return state.toastModal;
  },

  getSidebarStatus(state): boolean {
    return state.sidebarStatus;
  }
};
